
import { Component, Vue } from "vue-property-decorator";
import moment from "moment";

@Component({
  components: {
    Paginator: () => import("@/components/Paginator.vue"),
    SortColumn: () => import("@/components/SortColumn.vue")
  },
  computed: {},
  filters: {},
  watch: {
    $route(to, from) {
      (this as any).init();
    },
  },
})
export default class filesUpload extends Vue {
  data: any = {
    subscriptor: this.$store.state.user,
    companyId: this.$store.state.companyId,
    countryId: this.$store.state.user.companies[0].countryId,
    file: "",
  };
  isLoading: boolean = false;
  name: string = null;
  templateType: Number = 0;
  failedRequests = {};
  validRequests = {};
  validTemplate = {};
  massiveUploads = [];
  statuses = [];
  limit: number = 10;
  totalRows: number = 0;
  sortColumns: Record<string, string> = {
    name: "createdAt",
    owner: "Responsable",
    deletedAt: "Estado",
  };
  currentSort: Record<string, string> = {
    col: "createdAt",
    dir: "desc",
  };
  $refs!: {
    file: HTMLFormElement;
  };

  async mounted() {
    await this.loadStatuses();
    await this.init();
  }

  async init() {
    await (this as any).loadMassiveUploads(1, this.currentSort);
  }

  async onSelect() {
    const allowedTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    const file = this.$refs.file.files[0];
    this.data.file = file;
    if (!allowedTypes.includes(file.type)) {
      (this.$root as any).notify(
        "Solo archivos .xlsx pueden ser subidos.",
        "error"
      );
      this.resetLoad();
    }
  }
  
  async onSubmit() {
    this.isLoading = true;
    let valid = true

    if(this.name === "" || this.name === null) {
      (this.$root as any).notify(
        "Debe ingresar un nombre para identificar la carga masiva.",
        "error"
      );
      valid = false;
    }

    if(this.templateType === 0) {
      (this.$root as any).notify(
        "Seleccione el tipo de ramo de la carga masiva.",
        "error"
      );
      valid = false;
    }

    if(valid) {
      this.$modal.show("loading");

      const formData = new FormData();
      formData.append("name", this.name);
      formData.append("templateType", this.templateType.toString());
      formData.append("file", this.data.file);
      try {
        if (this.data.file) {
          const res: any = await (this.$root as any)._postFile(
            `requests/massiveUpload/${this.data.companyId}/${this.data.subscriptor.id}/${this.data.countryId}`,
            formData
          );

          this.validRequests = res.validationResponse.filter(function(success) {
            return success.validRow == true;
          });
          this.failedRequests = res.validationResponse.filter(function(fail) {
            return fail.validRow == false;
          });
          this.validTemplate = res.validationResponse.filter(function(wrong) {
            return wrong.validTemplate == false;
          });

          this.$modal.hide("loading");

          if (Object.keys(this.validTemplate).length == 0) {
            if (Object.keys(this.failedRequests).length > 0) {
              const showFailModal = this.show();
            } else {
              const showSuccessModal = this.showSuccess();
            }
          } else {
            const showWrongModal = this.showWrong();
          }

        } else {
          this.$modal.hide("loading");
          (this.$root as any).notify("No ha cargado un archivo.", "error");
        }
      } catch (e) {
        this.$modal.hide("loading");
        (this.$root as any).notify(e, "error");
        console.log("error", e);
      }

      this.toggleLoader();
      this.loadMassiveUploads(1, this.currentSort);
    }

    this.isLoading = false;
  }

  async exportTemplate() {
    if (this.templateType !== 0) {
      try {
        const response: any = await (this.$root as any)._get(
          `requests/template/${this.templateType}`
        );
        this.$modal.hide("massiveUploadWrongTemplate");
        this.resetLoad();
        let result = await (this.$root as any)._getFile(response.path);
        let fileName = response.path.split('/').slice(-1);
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute('download', fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();  
      } catch (e) {
        (this.$root as any).notify(
          "No se pudo exportar, intente más tarde.",
          "error"
        );
      }
    } else {
      (this.$root as any).notify(
        "Seleccione un tipo de ramo para descargar el template correspondiente.",
        "error"
      );
    }
  }
    
  async loadMassiveUploads(
    page: number,
    sort: Record<string, string>
  ) {
    this.currentSort = sort;
    const response: any = await (this.$root as any)._post(`companies/${this.data.companyId}/massiveUploads`, {
      limit: this.limit,
      page: page,
      order: this.currentSort
    });

    this.totalRows = response.totalRows;
    this.massiveUploads = response.data.map(mu => {
      mu.createdAt = moment(mu.createdAt).format("LLL");
      return mu;
    });
  }

  async onPageChange(page: number, limit: number) {
    this.limit = limit;
    await (this as any).loadMassiveUploads(page, this.currentSort);
  }

  async loadStatuses() {
    const response: any = await (this.$root as any)._get(`massiveuploads/status`);
    this.statuses = response;
  }

  statusClass(status) {
    if (status === 0 || status === 1) return "pending";
    if (status === 2) return "active";
    return "inactive";
  }

  statusMapping(status) {
    if(status === 0) return "Pendiente"
    if(status === 1) return "En progreso"
    if(status === 2) return "Finalizada"
    return "Error" 
  }
  
  resetLoad() {
    const input = document.getElementById("myFile") as HTMLInputElement;
    input.value = "";
    this.$modal.hide("massiveUploadSuccess");
    this.$modal.hide("massiveUploadFail");
  }
  show() {
    this.$modal.show("massiveUploadFail");
  }
  showSuccess() {
    this.$modal.show("massiveUploadSuccess");
  }
  showWrong() {
    this.$modal.show("massiveUploadWrongTemplate");
  }
  toggleLoader() {
    if(this.isLoading) {
      this.isLoading = false;
      this.$modal.hide("loading");
    } else {
      this.isLoading = true;
      this.$modal.show("loading");
    }
  }
}
